import Cell from './Cell';
import { PlayerColor } from '../types';

interface BoardProps {
  board: PlayerColor[][];
  onCellClick: (row: number, col: number) => void;
}

function Board({ board, onCellClick }: BoardProps) {
  console.debug("Board component is loaded");
  return (
    <div className="inline-block">
      {board.map((row, rowIndex) => (
        <div key={rowIndex} className="flex">
          {row.map((cell, colIndex) => (
            <Cell
              key={`${rowIndex}-${colIndex}`}
              value={cell}
              onClick={() => onCellClick(rowIndex, colIndex)}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export default Board;